module.exports = __webpack_public_path__ + "static/media/PoweredByDQ_white.a8c02ec6.png";